var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-success" },
    [
      _c("div", { staticClass: "success-title" }, [
        _c("div", { staticClass: "title-style" }, [
          _vm._v(_vm._s(_vm.$t("userManage.AccountCreationSuccessful"))),
        ]),
        _c("div", { staticStyle: { "font-size": "14px" } }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "userManage.PleaseExportTheLoginAccountAndInitialPasswordCreatedThisTimeImmediately"
              )
            )
          ),
        ]),
      ]),
      _c("div", { staticStyle: { margin: "20px 0" } }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "title-style",
            staticStyle: { "text-align": "center" },
          },
          [
            _vm._v(
              _vm._s(_vm.createData.createdCount) +
                " " +
                _vm._s(
                  _vm.$t(
                    "userManage.temporaryWorkerAccountsHaveBeenSuccessfullyCreated"
                  )
                )
            ),
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center", "font-size": "14px" } },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "userManage.TheAccountHasBeenCreatedAndWillTakeEffectImmediately"
                )
              )
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "warning-container" }, [
        _c("div", { staticClass: "warning-icon" }, [_vm._v(" ! ")]),
        _c("div", [
          _c("div", { staticStyle: { "font-weight": "bold", color: "#000" } }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "userManage.TheAccountAndInitialPasswordCanOnlyBeViewedAndExportedThisTime"
                )
              )
            ),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.$t("userManage.ForAccountSecurity")))]),
        ]),
      ]),
      _c(
        "div",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "create-batch" }, [
                  _c("div", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(_vm._s(_vm.$t("userManage.CreateBatch"))),
                  ]),
                  _c("div", { staticClass: "create-data" }, [
                    _vm._v(_vm._s(_vm.createData.batchNo)),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "create-batch" }, [
                  _c("div", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("userManage.NumberOfAccountsCreated"))
                    ),
                  ]),
                  _c("div", { staticClass: "create-data" }, [
                    _vm._v(_vm._s(_vm.createData.createdCount)),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "create-batch" }, [
                  _c("div", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(_vm._s(_vm.$t("userManage.creator"))),
                  ]),
                  _c("div", { staticClass: "create-data" }, [
                    _vm._v(_vm._s(_vm.createData.createUserName)),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "create-batch" }, [
                  _c("div", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(_vm._s(_vm.$t("GlobalSetObj.CreationTime"))),
                  ]),
                  _c("div", { staticClass: "create-data" }, [
                    _vm._v(_vm._s(_vm.createData.createTime)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "create-result-container" },
            [
              _c("div", { staticClass: "result-title" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("userManage.PreviewOfTheCreationResult"))
                ),
              ]),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.createData.createdRows,
                    "max-height": "300",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.compellation"),
                      prop: "realName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "CPF", prop: "cpf" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.owningTransitCenter1"),
                      prop: "hubCode",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("userManage.LoginAccount"),
                      prop: "username",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("userManage.InitialPassword"),
                      prop: "password",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("home.position"),
                      prop: "positionName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("userManage.NumberOfDaysTheAccountIsValid"),
                      prop: "validDays",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "export-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("userManage.ATotalOf")) +
                    " " +
                    _vm._s(_vm.createData.createdCount) +
                    " " +
                    _vm._s(_vm.$t("userManage.items")) +
                    "，" +
                    _vm._s(
                      _vm.$t("userManage.ThisPageOnlyDisplaysSomeExamples")
                    )
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "export-account" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  "font-weight": "bold",
                  color: "#000",
                },
              },
              [_vm._v(_vm._s(_vm.$t("userManage.ExportAccountAndPassword")))]
            ),
            _c(
              "div",
              { staticStyle: { "font-size": "12px", "margin-bottom": "10px" } },
              [
                _vm._v(
                  _vm._s(_vm.$t("userManage.TheExportedExcelFileWillInclude"))
                ),
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-bottom",
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.downloadModel },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("userManage.ExportAccountAndPasswordAtOnce")
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "submit-container" }, [
        _c("div", { staticStyle: { flex: "1", "font-size": "14px" } }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "userManage.recommendedConfirmThatTheExportHasBeenSuccessfulBeforeLeavingThisPage"
                )
              ) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticStyle: { flex: "1", "text-align": "right" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.uploadVerification },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("userManage.CompleteAndReturnTheAccountList"))
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("userManage.ConfirmAndReturnToAccountList"),
            visible: _vm.showConfirmTips,
            width: "800px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showConfirmTips = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "tips-container" }, [
              _vm.isDownload === 0
                ? _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("userManage.TheAccountsAndInitialPasswords")
                      )
                    ),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: { "font-weight": "bold", color: "#00a551" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "userManage.AccountAndPasswordHaveBeenExported"
                          )
                        )
                      ),
                    ]
                  ),
              _c("div", [
                _vm._v(_vm._s(_vm.$t("userManage.AfterLeavingThisPage"))),
              ]),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$t("userManage.UponReturning")))]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showConfirmTips = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmStillReturn },
                },
                [_vm._v(_vm._s(_vm.$t("userManage.StillReturn")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "success-container" }, [
      _c("div", { staticClass: "success-icon" }, [
        _c("i", {
          staticClass: "el-icon-check",
          staticStyle: { color: "#0db35b", "font-size": "50px" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }